import Vue from 'vue'
import Draggable from 'vuedraggable'
export default Draggable

Vue.use('draggable', Draggable)